import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { Filter2TableModule } from '@vendasta/va-filter2-table';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { ListsRoutingModule } from '../lists-routing.module';
import { DeleteUserColumnComponent } from './columns/delete-user-column.component';
import { UserEmailColumnComponent } from './columns/user-email-column.component';
import { UserListActionColumnComponent } from './columns/user-list-action-column.component';
import { UserListDateColumnComponent } from './columns/user-list-date-column.component';
import { UserListNameColumnComponent } from './columns/user-list-name-column.component';
import { UserNameColumnComponent } from './columns/user-name-column.component';
import { UserListsDetailsComponent } from './user-lists-details.component';
import { UserListsDetailsService } from './user-lists-details.service';
import { UserListsOverviewComponent } from './user-lists-overview.component';
import { UserListsOverviewService } from './user-lists-overview.service';

const MAT_MODULES = [
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatRadioModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatTableModule,
  GalaxyPipesModule,
];

@NgModule({
  imports: [
    ListsRoutingModule,
    MAT_MODULES,
    FormsModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    RouterModule,
    Filter2TableModule,
    GalaxyPageModule,
  ],
  declarations: [
    UserListsOverviewComponent,
    UserListNameColumnComponent,
    UserListDateColumnComponent,
    UserListActionColumnComponent,
    UserListsDetailsComponent,
    UserNameColumnComponent,
    UserEmailColumnComponent,
    DeleteUserColumnComponent,
  ],
  exports: [UserListsOverviewComponent, UserListsDetailsComponent],
  providers: [UserListsOverviewService, UserListsDetailsService],
})
export class UserListModule {}
